/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateUserResponse } from './CreateUserResponse';
import {
    CreateUserResponseFromJSON,
    CreateUserResponseFromJSONTyped,
    CreateUserResponseToJSON,
    CreateUserResponseToJSONTyped,
} from './CreateUserResponse';

/**
 * 
 * @export
 * @interface ResultOfCreateUserResponse
 */
export interface ResultOfCreateUserResponse {
    /**
     * 
     * @type {CreateUserResponse}
     * @memberof ResultOfCreateUserResponse
     */
    data: CreateUserResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfCreateUserResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfCreateUserResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfCreateUserResponse interface.
 */
export function instanceOfResultOfCreateUserResponse(value: object): value is ResultOfCreateUserResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfCreateUserResponseFromJSON(json: any): ResultOfCreateUserResponse {
    return ResultOfCreateUserResponseFromJSONTyped(json, false);
}

export function ResultOfCreateUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfCreateUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CreateUserResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfCreateUserResponseToJSON(json: any): ResultOfCreateUserResponse {
    return ResultOfCreateUserResponseToJSONTyped(json, false);
}

export function ResultOfCreateUserResponseToJSONTyped(value?: ResultOfCreateUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateUserResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

